import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'

export default class HelplinePolicyModel extends CosmosJobsDbRecordBase {
  public helplineEmail: string
}
